<template>

    <div v-if="isLoading" class="loading-overlay">
        <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Cargando...</span>
        </div>
    </div>


    <div class="row">

        <div class="col-xl-12 d-flex">
            <div class="card super-admin-dash-card">
                <div class="card-header">
                    <div class="row align-items-center">
                        <div class="col">
                            <h5 class="card-title mb-0">
                                <i class="fas fa-box me-2"></i>
                                Lista de Productos ({{ filteredProducts.length }})
                            </h5>
                        </div>
                        <div class="col-auto">
                            <div class="btn-group me-2" role="group">
                                <button
                                    type="button"
                                    class="btn btn-sm"
                                    :class="vistaTabla === 'grid' ? 'btn-primary' : 'btn-outline-primary'"
                                    @click="vistaTabla = 'grid'"
                                >
                                    <i class="fas fa-th"></i>
                                </button>
                                <button
                                    type="button"
                                    class="btn btn-sm"
                                    :class="vistaTabla === 'table' ? 'btn-primary' : 'btn-outline-primary'"
                                    @click="vistaTabla = 'table'"
                                >
                                    <i class="fas fa-list"></i>
                                </button>
                            </div>
                            <button class="create-product-btn" @click="goToCreateProduct">
                                <i class="fas fa-plus-circle me-2"></i>Nuevo Producto
                            </button>
                        </div>
                    </div>
                    <div class="row mt-3">
                        <div class="col-12">
                            <div class="d-flex align-items-center gap-3">
                                <div class="search-box flex-grow-1">
                                    <input
                                        type="text"
                                        v-model="searchTerm"
                                        class="form-control search-input"
                                        placeholder="Buscar por nombre, categoría, subcategoría..."
                                    />
                                    <span v-if="searchTerm" class="clear-search" @click="clearSearch">
                                        <i class="fas fa-times"></i>
                                    </span>
                                </div>
                                <span class="text-muted text-nowrap">{{ filteredProducts.length }} de {{ products.length }} productos</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card-body p-0">
                    <!-- Vista de Tabla -->
                    <div v-if="vistaTabla === 'table'" class="table-responsive">
                        <table class="table table-hover">
                            <thead>
                                <tr>
                                    <th width="60">Imagen</th>
                                    <th>Producto</th>
                                    <th>Categoría</th>
                                    <th>Sub-Categoría</th>
                                    <th>Costo</th>
                                    <th>Precio</th>
                                    <th class="text-center">Stock</th>
                                    <th class="text-center">Acciones</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-if="paginatedProducts.length === 0">
                                    <td colspan="8" class="text-center py-5">
                                        <i class="fas fa-inbox fa-3x text-muted mb-3 d-block"></i>
                                        <p class="text-muted mb-0">No se encontraron productos{{ searchTerm ? ' con el término de búsqueda' : '' }}</p>
                                    </td>
                                </tr>
                                <tr v-for="product in paginatedProducts" :key="product.id">
                                    <td class="text-center align-middle">
                                        <img
                                            :src="baseURL + '/producto/obtener_image_producto/' + product.portada.split('/').pop()"
                                            :alt="product.titulo"
                                            class="img-thumbnail"
                                            style="width: 50px; height: 50px; object-fit: cover;"
                                        />
                                    </td>
                                    <td>
                                        <strong>{{ product.titulo }}</strong>
                                        <br />
                                        <small class="text-muted">{{ product.slug }}</small>
                                    </td>
                                    <td>
                                        <span class="badge bg-info">{{ product.categoria.nombre }}</span>
                                    </td>
                                    <td>
                                        <span class="badge bg-secondary">{{ product.subCategoria.nombre }}</span>
                                    </td>
                                    <td>
                                        <strong class="text-muted">${{ Number(product.costo).toFixed(2) }}</strong>
                                    </td>
                                    <td>
                                        <strong class="text-success">${{ Number(product.precio).toFixed(2) }}</strong>
                                    </td>
                                    <td class="text-center">
                                        <h5 class="mb-0" :class="{
                                            'text-danger': product.stock === 0,
                                            'text-warning': product.stock > 0 && product.stock <= 5,
                                            'text-success': product.stock > 5
                                        }">
                                            {{ product.stock || 0 }}
                                        </h5>
                                    </td>
                                    <td class="text-center">
                                        <div class="btn-group btn-group-sm" role="group">
                                            <!-- Icono para Galería -->
                                            <router-link
                                                :to="{ name: 'galeryProduct', params: { id: product.id } }"
                                                class="btn btn-outline-secondary"
                                                title="Galería de fotos"
                                            >
                                                <i class="fas fa-images"></i>
                                            </router-link>

                                            <!-- Icono para Editar -->
                                            <router-link
                                                :to="{ name: 'editProduct', params: { id: product.id } }"
                                                class="btn btn-outline-primary"
                                                title="Editar producto"
                                            >
                                                <i class="fas fa-edit"></i>
                                            </router-link>

                                            <!-- Icono para Inventario -->
                                            <button
                                                class="btn btn-outline-warning"
                                                title="Actualizar inventario"
                                                @click="openInventoryModal(product)"
                                            >
                                                <i class="fas fa-boxes"></i>
                                            </button>

                                            <!-- Icono para Ver -->
                                            <a
                                                :href="baseURL + '/producto/' + product.slug"
                                                target="_blank"
                                                class="btn btn-outline-info"
                                                title="Ver en página"
                                            >
                                                <i class="fas fa-eye"></i>
                                            </a>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <!-- Vista de Grid -->
                    <div v-if="vistaTabla === 'grid'" class="p-3">
                        <div class="row g-3">
                            <div v-if="paginatedProducts.length === 0" class="col-12 text-center py-5">
                                <i class="fas fa-inbox fa-3x text-muted mb-3"></i>
                                <p class="text-muted">No se encontraron productos{{ searchTerm ? ' con el término de búsqueda' : '' }}</p>
                            </div>
                            <div v-for="product in paginatedProducts" :key="product.id" class="col-md-6 col-lg-4 col-xl-3">
                                <div
                                    class="card product-card h-100"
                                    :class="{
                                        'border-danger': product.stock === 0,
                                        'border-warning': product.stock > 0 && product.stock <= 5
                                    }"
                                >
                                    <div class="product-image-wrapper">
                                        <img
                                            :src="baseURL + '/producto/obtener_image_producto/' + product.portada.split('/').pop()"
                                            class="card-img-top"
                                            :alt="product.titulo"
                                        />
                                        <span
                                            class="badge position-absolute top-0 end-0 m-2"
                                            :class="{
                                                'bg-danger': product.stock === 0,
                                                'bg-warning': product.stock > 0 && product.stock <= 5,
                                                'bg-success': product.stock > 5
                                            }"
                                        >
                                            {{ product.stock === 0 ? 'Agotado' : product.stock <= 5 ? 'Bajo Stock' : 'Disponible' }}
                                        </span>
                                    </div>
                                    <div class="card-body">
                                        <h6 class="card-title text-truncate" :title="product.titulo">
                                            {{ product.titulo }}
                                        </h6>
                                        <p class="text-muted mb-2">
                                            <small>{{ product.categoria.nombre }}</small>
                                        </p>
                                        <div class="mb-2">
                                            <span class="badge bg-info me-1">{{ product.categoria.nombre }}</span>
                                            <span class="badge bg-secondary">{{ product.subCategoria.nombre }}</span>
                                        </div>
                                        <div class="d-flex justify-content-between align-items-center mb-2">
                                            <div>
                                                <small class="text-muted d-block">Costo</small>
                                                <strong class="text-muted">${{ Number(product.costo).toFixed(2) }}</strong>
                                            </div>
                                            <div>
                                                <small class="text-muted d-block">Precio</small>
                                                <strong class="text-success">${{ Number(product.precio).toFixed(2) }}</strong>
                                            </div>
                                        </div>
                                        <div class="d-flex justify-content-between align-items-center mb-3">
                                            <div>
                                                <small class="text-muted">Stock:</small>
                                                <h5
                                                    class="mb-0 d-inline ms-1"
                                                    :class="{
                                                        'text-danger': product.stock === 0,
                                                        'text-warning': product.stock > 0 && product.stock <= 5,
                                                        'text-success': product.stock > 5
                                                    }"
                                                >
                                                    {{ product.stock || 0 }}
                                                </h5>
                                            </div>
                                        </div>
                                        <div class="btn-group w-100" role="group">
                                            <router-link
                                                :to="{ name: 'galeryProduct', params: { id: product.id } }"
                                                class="btn btn-sm btn-outline-secondary"
                                                title="Galería de fotos"
                                            >
                                                <i class="fas fa-images"></i>
                                            </router-link>
                                            <router-link
                                                :to="{ name: 'editProduct', params: { id: product.id } }"
                                                class="btn btn-sm btn-outline-primary"
                                                title="Editar producto"
                                            >
                                                <i class="fas fa-edit"></i>
                                            </router-link>
                                            <button
                                                class="btn btn-sm btn-outline-warning"
                                                title="Actualizar inventario"
                                                @click="openInventoryModal(product)"
                                            >
                                                <i class="fas fa-boxes"></i>
                                            </button>
                                            <a
                                                :href="baseURL + '/producto/' + product.slug"
                                                target="_blank"
                                                class="btn btn-sm btn-outline-info"
                                                title="Ver en página"
                                            >
                                                <i class="fas fa-eye"></i>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Paginación -->
                <div class="card-footer" v-if="filteredProducts.length > 0">
                    <div class="row align-items-center">
                        <div class="col">
                            <p class="mb-0 text-muted">
                                Mostrando {{ rangoInicio }} a {{ rangoFin }} de {{ filteredProducts.length }} productos
                            </p>
                        </div>
                        <div class="col-auto">
                            <nav>
                                <ul class="pagination pagination-sm mb-0">
                                    <li class="page-item" :class="{ disabled: paginacion.paginaActual === 1 }">
                                        <a class="page-link" href="#" @click.prevent="cambiarPagina(paginacion.paginaActual - 1)">
                                            <i class="fas fa-chevron-left"></i>
                                        </a>
                                    </li>
                                    <li
                                        class="page-item"
                                        v-for="pagina in paginasVisibles"
                                        :key="pagina"
                                        :class="{ active: pagina === paginacion.paginaActual }"
                                    >
                                        <a class="page-link" href="#" @click.prevent="cambiarPagina(pagina)">
                                            {{ pagina }}
                                        </a>
                                    </li>
                                    <li class="page-item" :class="{ disabled: paginacion.paginaActual === totalPaginas }">
                                        <a class="page-link" href="#" @click.prevent="cambiarPagina(paginacion.paginaActual + 1)">
                                            <i class="fas fa-chevron-right"></i>
                                        </a>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Modal Actualizar Inventario -->
    <div class="modal fade" id="inventoryModal" tabindex="-1" ref="inventoryModal">
        <div class="modal-dialog" :class="{ 'modal-lg': hasVarieties }">
            <div class="modal-content">
                <div class="modal-header bg-warning bg-opacity-10">
                    <h5 class="modal-title">
                        <i class="fas fa-boxes me-2"></i>Actualizar Inventario
                    </h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                </div>
                <div class="modal-body" v-if="selectedProduct">
                    <div class="d-flex align-items-center mb-3 p-3 bg-light rounded">
                        <img
                            :src="baseURL + '/producto/obtener_image_producto/' + selectedProduct.portada.split('/').pop()"
                            :alt="selectedProduct.titulo"
                            class="img-thumbnail me-3"
                            style="width: 60px; height: 60px; object-fit: cover;"
                        />
                        <div>
                            <h6 class="mb-0">{{ selectedProduct.titulo }}</h6>
                            <small class="text-muted">Stock actual: {{ selectedProduct.stock || 0 }}</small>
                        </div>
                    </div>

                    <!-- Sin variedades -->
                    <div v-if="!hasVarieties">
                        <div class="input-block">
                            <label for="stockInput" class="form-label fw-bold">Nuevo Stock</label>
                            <input
                                type="number"
                                id="stockInput"
                                v-model.number="inventoryStock"
                                class="form-control form-control-lg text-center"
                                min="0"
                                placeholder="Ingrese el stock"
                            />
                        </div>
                    </div>

                    <!-- Con variedades -->
                    <div v-else>
                        <div v-if="loadingVarieties" class="text-center py-4">
                            <div class="spinner-border text-warning" role="status">
                                <span class="visually-hidden">Cargando variedades...</span>
                            </div>
                        </div>
                        <div v-else>
                            <div class="table-responsive">
                                <table class="table table-hover">
                                    <thead>
                                        <tr>
                                            <th>SKU</th>
                                            <th v-if="selectedProduct.talla">Talla</th>
                                            <th v-if="selectedProduct.color">Color</th>
                                            <th v-if="selectedProduct.medida">Medida</th>
                                            <th class="text-center" style="width: 150px;">Stock</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="variedad in inventoryVarieties" :key="variedad.id">
                                            <td class="align-middle">
                                                <small class="text-muted">{{ variedad.sku }}</small>
                                            </td>
                                            <td class="align-middle" v-if="selectedProduct.talla">{{ variedad.talla }}</td>
                                            <td class="align-middle" v-if="selectedProduct.color">{{ variedad.color }}</td>
                                            <td class="align-middle" v-if="selectedProduct.medida">{{ variedad.medida }}</td>
                                            <td>
                                                <input
                                                    type="number"
                                                    v-model.number="variedad.stock"
                                                    class="form-control text-center"
                                                    min="0"
                                                />
                                            </td>
                                        </tr>
                                    </tbody>
                                    <tfoot>
                                        <tr>
                                            <td :colspan="1 + (selectedProduct.talla ? 1 : 0) + (selectedProduct.color ? 1 : 0) + (selectedProduct.medida ? 1 : 0)" class="text-end fw-bold">
                                                Total:
                                            </td>
                                            <td class="text-center fw-bold text-success">
                                                {{ totalVarietyStock }}
                                            </td>
                                        </tr>
                                    </tfoot>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancelar</button>
                    <button
                        type="button"
                        class="btn btn-warning"
                        @click="updateInventory"
                        :disabled="savingInventory"
                    >
                        <span v-if="savingInventory" class="spinner-border spinner-border-sm me-1"></span>
                        <i v-else class="fas fa-save me-1"></i>
                        Actualizar Inventario
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/api';

export default {

    data() {
        return {
            isLoading: false,
            products: [],
            baseURL: api.defaults.baseURL,
            searchTerm: '',
            vistaTabla: 'table',
            paginacion: {
                paginaActual: 1,
                porPagina: 10
            },
            selectedProduct: null,
            inventoryStock: 0,
            inventoryVarieties: [],
            loadingVarieties: false,
            savingInventory: false,
            inventoryModal: null
        };
    },
    mounted() {
        this.loadProducts();
    },

    watch: {
        searchTerm() {
            // Resetear a la primera página cuando se busca
            this.paginacion.paginaActual = 1;
        }
    },

    methods: {
        async loadProducts() {
            try {
                const response = await api.get('/producto/buscar');
                this.products = response.data;
                console.log(this.products);
            } catch (err) {
                this.error = 'Error al cargar sub-categorías';
                console.error(err);
            } finally {
                this.isLoading = false;
            }
        },
        goToCreateProduct() {
            //this.$router.push({ name: 'product' });

            // Alternativa usando path:
            this.$router.push('/product/product');
        },
        clearSearch() {
            this.searchTerm = '';
            this.paginacion.paginaActual = 1;
        },
        cambiarPagina(pagina) {
            if (pagina >= 1 && pagina <= this.totalPaginas) {
                this.paginacion.paginaActual = pagina;
                window.scrollTo({ top: 0, behavior: 'smooth' });
            }
        },
        async openInventoryModal(product) {
            this.selectedProduct = product;
            this.inventoryStock = product.stock || 0;
            this.inventoryVarieties = [];

            if (!this.inventoryModal) {
                const bootstrap = await import('bootstrap');
                this.inventoryModal = new bootstrap.Modal(this.$refs.inventoryModal);
            }

            if (this.hasVarieties) {
                this.loadingVarieties = true;
                try {
                    const response = await api.get(`/variedad/${product.id}`);
                    this.inventoryVarieties = response.data.map(v => ({ ...v, stock: v.stock || 0 }));
                } catch (err) {
                    console.error(err);
                    this.$toast.error('Error al cargar variedades');
                } finally {
                    this.loadingVarieties = false;
                }
            }

            this.inventoryModal.show();
        },
        async updateInventory() {
            this.savingInventory = true;
            let body;

            if (this.hasVarieties) {
                body = {
                    variedades: this.inventoryVarieties.map(v => ({
                        id: v.id,
                        stock: v.stock
                    }))
                };
            } else {
                body = { stock: this.inventoryStock };
            }

            try {
                await api.put(`/producto/actualizar_inventario/${this.selectedProduct.id}`, body);
                this.$toast.success('Inventario actualizado con éxito');
                this.inventoryModal.hide();
                this.loadProducts();
            } catch (error) {
                console.error(error);
                this.$toast.error('Error al actualizar el inventario');
            } finally {
                this.savingInventory = false;
            }
        }
    },
    computed: {
        filteredProducts() {
            if (!this.searchTerm) {
                return this.products;
            }

            const search = this.searchTerm.toLowerCase().trim();

            return this.products.filter(product => {
                // Buscar en título
                const matchTitulo = product.titulo?.toLowerCase().includes(search);

                // Buscar en slug
                const matchSlug = product.slug?.toLowerCase().includes(search);

                // Buscar en categoría
                const matchCategoria = product.categoria?.nombre?.toLowerCase().includes(search);

                // Buscar en subcategoría
                const matchSubCategoria = product.subCategoria?.nombre?.toLowerCase().includes(search);

                // Buscar en stock (convertido a string)
                const matchStock = product.stock?.toString().includes(search);

                // Buscar en costo
                const matchCosto = product.costo?.toString().includes(search);

                // Buscar en precio
                const matchPrecio = product.precio?.toString().includes(search);

                return matchTitulo || matchSlug || matchCategoria || matchSubCategoria ||
                       matchStock || matchCosto || matchPrecio;
            });
        },
        paginatedProducts() {
            const inicio = (this.paginacion.paginaActual - 1) * this.paginacion.porPagina;
            const fin = inicio + this.paginacion.porPagina;
            return this.filteredProducts.slice(inicio, fin);
        },
        totalPaginas() {
            return Math.ceil(this.filteredProducts.length / this.paginacion.porPagina);
        },
        paginasVisibles() {
            const total = this.totalPaginas;
            const actual = this.paginacion.paginaActual;
            const paginas = [];

            if (total <= 7) {
                for (let i = 1; i <= total; i++) {
                    paginas.push(i);
                }
            } else {
                if (actual <= 4) {
                    for (let i = 1; i <= 5; i++) paginas.push(i);
                    paginas.push('...');
                    paginas.push(total);
                } else if (actual >= total - 3) {
                    paginas.push(1);
                    paginas.push('...');
                    for (let i = total - 4; i <= total; i++) paginas.push(i);
                } else {
                    paginas.push(1);
                    paginas.push('...');
                    for (let i = actual - 1; i <= actual + 1; i++) paginas.push(i);
                    paginas.push('...');
                    paginas.push(total);
                }
            }

            return paginas.filter(p => p !== '...' || paginas.indexOf(p) === paginas.lastIndexOf(p));
        },
        rangoInicio() {
            if (this.filteredProducts.length === 0) return 0;
            return (this.paginacion.paginaActual - 1) * this.paginacion.porPagina + 1;
        },
        rangoFin() {
            const fin = this.paginacion.paginaActual * this.paginacion.porPagina;
            return fin > this.filteredProducts.length ? this.filteredProducts.length : fin;
        },
        hasVarieties() {
            if (!this.selectedProduct) return false;
            return this.selectedProduct.talla || this.selectedProduct.color || this.selectedProduct.medida;
        },
        totalVarietyStock() {
            return this.inventoryVarieties.reduce((total, v) => total + (parseInt(v.stock) || 0), 0);
        }
    }

};
</script>

<style scoped>
.is-invalid {
    border-color: #dc3545;
}

.table thead th {
    border-top: none;
    background-color: #f8f9fa;
    font-weight: 600;
    font-size: 0.875rem;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    color: #6c757d;
}

.table tbody tr {
    transition: background-color 0.2s ease;
}

.table tbody tr:hover {
    background-color: #f8f9fa;
}

.loading-overlay {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1050;
    width: 100vw;
    height: 100vh;
    background-color: rgba(255, 255, 255, 0.2);
    display: flex;
    align-items: center;
    justify-content: center;
    backdrop-filter: blur(2px);
}

.small-lg {
    font-size: 0.9rem !important;
}

.badge {
    font-weight: 500;
    padding: 0.35em 0.65em;
}

.btn-group {
    white-space: nowrap;
}

.card {
    border: none;
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.08);
}

.create-product-btn {
    background-color: #4e73df;
    color: white;
    border: none;
    padding: 8px 16px;
    border-radius: 6px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.3s ease;
    display: inline-flex;
    align-items: center;
}

.create-product-btn:hover {
    background-color: #2e59d9;
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(78, 115, 223, 0.3);
}

.create-product-btn:active {
    transform: translateY(0);
}

.search-box {
    position: relative;
    display: flex;
    align-items: center;
}

.search-input {
    padding-left: 12px;
    padding-right: 38px;
    border-radius: 8px;
    border: 1px solid #dee2e6;
    transition: all 0.3s ease;
    width: 100%;
}

.search-input:focus {
    border-color: #4e73df;
    box-shadow: 0 0 0 0.2rem rgba(78, 115, 223, 0.15);
}

.clear-search {
    position: absolute;
    right: 12px;
    color: #6c757d;
    cursor: pointer;
    z-index: 1;
    padding: 4px;
    transition: color 0.2s;
}

.clear-search:hover {
    color: #dc3545;
}

/* Estilos de paginación */
.pagination {
    gap: 0.25rem;
    margin-bottom: 0;
}

.page-link {
    border-radius: 0.25rem;
    border: 1px solid #dee2e6;
    color: #667eea;
}

.page-link:hover {
    background-color: #f8f9fa;
    color: #667eea;
}

.page-item.active .page-link {
    background-color: #667eea;
    border-color: #667eea;
}

.card-footer {
    background-color: #f8f9fa;
    border-top: 1px solid #e9ecef;
    padding: 1rem 1.5rem;
}

/* Estilos para vista de Grid */
.product-card {
    transition: transform 0.3s ease, box-shadow 0.3s ease;
    overflow: hidden;
}

.product-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 5px 25px rgba(0, 0, 0, 0.15);
}

.product-card.border-warning {
    border: 2px solid #ffc107;
}

.product-card.border-danger {
    border: 2px solid #dc3545;
}

.product-image-wrapper {
    position: relative;
    height: 200px;
    overflow: hidden;
    background-color: #f8f9fa;
}

.product-image-wrapper img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

@media (max-width: 768px) {
    .product-image-wrapper {
        height: 150px;
    }
}
</style>
